import { render, staticRenderFns } from "./projectcardBox.vue?vue&type=template&id=d56f6a72&scoped=true"
import script from "./projectcardBox.vue?vue&type=script&lang=js"
export * from "./projectcardBox.vue?vue&type=script&lang=js"
import style0 from "./projectcardBox.vue?vue&type=style&index=0&id=d56f6a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56f6a72",
  null
  
)

export default component.exports